import { c as _c } from "react/compiler-runtime";
import { cn } from '@tallinn-arvudes/ui/utils';
import { type DetailedHTMLProps, type HTMLAttributes } from 'react';
import './styles.scss';
export const Skeleton = t0 => {
  const $ = _c(10);
  let className;
  let isLoading;
  let props;
  if ($[0] !== t0) {
    ({
      isLoading,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = isLoading;
    $[3] = props;
  } else {
    className = $[1];
    isLoading = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className || $[5] !== isLoading) {
    t1 = cn(className, {
      "skeleton-loading": isLoading
    });
    $[4] = className;
    $[5] = isLoading;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== t1) {
    t2 = <div {...props} className={t1} />;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};